<template>
  <div id="recuperar-contrasena">
    <Volver redireccion="OlvidoContrasena" />
    <Titulo
      :subtitulo="
        `Ingresa el código de seguridad enviado a tu medio de contacto registrado en la plataforma`
      "
    >
      <b-col cols="12" md="6" order="0" class="mt-3">
        <label class="mb-1 font-weight-bold">Código de seguridad</label>
        <b-form-input
          data-testid="form-codigo-validacion"
          type="text"
          class="form-control-lg placeholder"
          v-model="codigoValidacion"
          :state="tieneError('codigo')"
          @keyup.once="modificado.push('codigo')"
          @change="validarCodigoValid()"
          trim
          autocomplete="off"
        ></b-form-input>
        <b-form-invalid-feedback>{{
          mensajeError("codigo")
        }}</b-form-invalid-feedback>
      </b-col>
      <b-col cols="12" md="6" order="2" order-lg="1" class="mt-4 mt-lg-3">
        <InputPasswordWrapper
          dataTestid="form-clave-nueva"
          etiqueta="Ingresa una nueva contraseña"
          negrita="true"
          grande="true"
          maxlength="50"
          v-model="recuperar.clave"
          :estado="this.tieneError('password')"
          :mensajeError="this.mensajeError('password')"
          @keyup.once="modificado.push('password', 'password2')"
          @change="validarPassword('password', recuperar.clave)"
          onCopy="return false"
          onPaste="return false"
        />
      </b-col>
      <b-col cols="12" md="6" order="1" order-lg="2" class="mt-2 text-gris"
        >Código de seguridad enviado al medio de contacto registrado en la
        plataforma</b-col
      >
      <b-col cols="12" md="6" order="3" class="mt-4">
        <InputPasswordWrapper
          dataTestid="form-clave-confirmar"
          etiqueta="Confirmar la nueva contraseña"
          negrita="true"
          grande="true"
          maxlength="50"
          v-model="confirmarClave"
          :estado="this.tieneError('password2')"
          :mensajeError="this.mensajeError('password2')"
          @keyup.once="modificado.push('password2')"
          @keyup="validarPassword('password2', confirmarClave)"
          onCopy="return false"
          onPaste="return false"
        />
      </b-col>
      <b-col
        cols="12"
        order="4"
        class="mb-2 mt-3 mt-lg-5 px-0 px-lg-3 text-center mb-5"
      >
        <button
          data-testid="button-cambiar-clave"
          id="enviar-form"
          class="btn-lg btn-azul-oscuro2 gilmer text-left pr-3 mt-2 text-uppercase px-4 font-weight-bold"
          @click="validarFomulario() ? enviarFormualrio() : false"
        >
          Cambiar contraseña
        </button>
        <div md="6" class="mt-4 text-gris">
          En caso de no recibir el código de seguridad contactarse al 600 600
          2626
        </div>
      </b-col>
    </Titulo>
    <Modal
      ref="modalExitoso"
      tituloMensaje="Cambio de clave exitoso"
      mensaje="Ya puedes acceder al Sistema de Admisión Escolar."
      destino="Inicio"
      tipoModal="EXITO"
      textoBoton="Ir a Página de inicio "
    ></Modal>
  </div>
</template>
<script>
import Volver from "@/components/generales/Volver";
import Titulo from "@/components/generales/TituloRecuperarContrasena";
import { manejoErrores } from "@/assets/js/manejoErrores";
import InputPasswordWrapper from "@/components/generales/inputs/InputPasswordWrapper";
import Validador from "@/assets/js/validador";
import ApiLogin from "@/services/ApiLogin";
import Modal from "@/components/generales/modales/Mensaje";
export default {
  mixins: [manejoErrores],
  components: {
    Volver,
    Titulo,
    InputPasswordWrapper,
    Modal
  },
  data() {
    return {
      recuperar: {
        id: this.$route.params.id,
        medio:
          this.$route.params.medio == "correo"
            ? 0
            : this.$route.params.medio == "telefono"
            ? 1
            : 2,
        numeroValidacion: "",
        clave: ""
      },
      medioSeleccionado: [
        { text: "correo electrónico" },
        { text: "teléfono móvil" }
      ],
      codigoValidacion: "",
      confirmarClave: ""
    };
  },
  methods: {
    async enviarFormualrio() {
      let cambiarclave = await ApiLogin.cambiarClave(this.recuperar, this);
      if (cambiarclave) {
        this.$refs.modalExitoso.showModal();
      }
      this.$emit("cargado");
      return true;
    },
    validarFomulario() {
      this.$emit("cargar");
      let validado = true;
      this.modificado = ["codigo", "password", "password2"];
      let valido = [
        this.validarCodigoValid(),
        this.validarPassword("password", this.recuperar.clave),
        this.validarPassword("password2", this.confirmarClave)
      ];
      if (valido.includes(false)) {
        validado = false;
        this.$emit("cargado");
      }
      return validado;
    },
    validarCodigoValid() {
      let valor = this.codigoValidacion;
      let campo = "codigo";
      let valido = true;
      this.limpiarError(campo);
      if (valor.length < 1) {
        this.guardarError(
          campo,
          "Debe ingresar el código de seguridad enviado al medio de contacto seleccionado."
        );
        valido = false;
      }
      if (valido) {
        this.recuperar.numeroValidacion = parseInt(valor);
      }
      return valido;
    },
    validarPassword(campo, valor) {
      let valido = true;
      let mensaje = "Contraseña no válida: ";
      let errores = [];
      this.limpiarError(campo);

      if (valor.length < 1) {
        errores.push("La contraseña es un campo obligatorio");
      } else if (!Validador.validarExpresion("password", valor)) {
        errores.push(
          "La contraseña debe tener mínimo 8 caracteres y debe contener al menos una letra mayúscula, una letra minúscula, un número y un símbolo. Ejemplo contraseña: Abcdef1#"
        );
      }
      if (errores.length > 0) {
        this.guardarError(campo, errores[0]);
        valido = false;
      }

      if (valido) {
        this.limpiarError("password");
        this.limpiarError("password2");
        if (!(this.recuperar.clave === this.confirmarClave)) {
          this.guardarError("password", "");
          this.guardarError(
            "password2",
            "Las contraseñas ingresadas no coinciden"
          );
          valido = false;
        }
      }
      return valido;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/RecuperarContrasena.vue